import { render, staticRenderFns } from "./SkeletonBoxList.vue?vue&type=template&id=40f4024b"
import script from "./SkeletonBoxList.vue?vue&type=script&lang=js"
export * from "./SkeletonBoxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports